import { render, staticRenderFns } from "./zip-file.vue?vue&type=template&id=6b5c43a8"
import script from "./zip-file.vue?vue&type=script&lang=js"
export * from "./zip-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports